import TransferTableNew from './views/TransferTableNew.c';
export default TransferTableNew;
